<script lang="ts" setup>
import { computed, ref } from 'vue'
import { useInfiniteScroll } from '@vueuse/core'
import { useRouter } from 'vue-router/composables'
import { consumeCommonConfig } from './configs/common'
import ConsumePageDefault from './components/ConsumePage.default.vue'
import ConsumePageFlipnovel from './components/ConsumePage.flipnovel.vue'
import ConsumePageNovelmello from './components/ConsumePage.novelmello.vue'
import { api } from '@/api'
import { READER_ROUTE_NAME } from '@/utils/readerRouteName'
import { loadBrandComponent } from '@/utils/loadBrandConfig'

const config = consumeCommonConfig

const ConsumePage = loadBrandComponent({
  rocnovel: ConsumePageDefault,
  oceread: ConsumePageDefault,
  talewave: ConsumePageDefault,
  ficmoon: ConsumePageDefault,
  novelarc: ConsumePageDefault,
  storyella: ConsumePageDefault,
  aurenovel: ConsumePageDefault,
  silktale: ConsumePageDefault,
  pearla: ConsumePageDefault,
  fictora: ConsumePageDefault,
  marinovel: ConsumePageDefault,
  flipnovel: ConsumePageFlipnovel,
  novelmello: ConsumePageNovelmello,
})

const records = ref<any[]>([])
const page = ref(1)
const fetching = ref(false)
const ending = ref(false)
const error = ref<any>()
const pagination = computed(() => ({
  pageIndex: page.value,
  pageSize: 20,
}))

async function fetchFeed() {
  fetching.value = true
  try {
    const { data } = await api.get<any, GetMemberGetconsumerecordlistResponse>('/member/getConsumeRecordList', { params: { ...pagination.value } })
    records.value = [...records.value, ...data.records]
    if (page.value >= data.pages)
      ending.value = true
    else
      page.value += 1
  }
  catch (_error) {
    error.value = _error
  }
  finally {
    fetching.value = false
  }
}
const infiniteRef = ref<HTMLElement>()
function setInfiniteRef(el: HTMLElement | null) {
  infiniteRef.value = el || undefined
}
useInfiniteScroll(infiniteRef,
  async () => {
    if (fetching.value || ending.value || error.value)
      return
    await fetchFeed()
  },
  { distance: 50 },
)

const router = useRouter()
function gotoChapter(item: any) {
  router.replace({
    name: READER_ROUTE_NAME,
    params: {
      contentId: item.contentId,
      chapterId: item.chapterId,
    },
  })
}
</script>

<template>
  <ConsumePage
    :config="config"
    :records="records"
    :fetching="fetching"
    :ending="ending"
    :page="page"
    :set-infinite-ref="setInfiniteRef"
    :goto-chapter="gotoChapter"
  />
</template>
